<div class="jbm-state-dropdown">
   <label for="stateDropdown" class="float-start">{{'quotation.state'|translate}}:</label>
   <div ngbDropdown>
      <button type="button" class="btn btn-light float-start" id="stateDropdown" ngbDropdownToggle>
         <span *ngIf="!id">{{'ui.all'|translate}}</span>
         <span *ngIf="id">{{quotationState.description}}</span>
      </button>
      <div ngbDropdownMenu aria-labelledby="stateDropdown">
         <button type="button" *ngIf="id" ngbDropdownItem (click)="setQuotationState(0)">
            <span class="badge badge-pill bg-white">{{'ui.all'|translate}}</span>
         </button>
         <div *ngFor="let qs of quotationStates">
            <button type="button" *ngIf="!(qs.id==id)" ngbDropdownItem (click)="setQuotationState(qs.id)">
               <span class="badge badge-pill opacity-7" style="background-color: {{qs.color}}; color:{{qs.text_color}}">
                  {{qs.description}}
               </span>
            </button>
         </div>
      </div>
   </div>
</div>
